import { Component, ElementRef, Input, OnDestroy } from '@angular/core';
import { Filterable } from '@common/utilities/Filterable';

@Component({
  selector: 'pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnDestroy {


  @Input()
  public target: Filterable<any>;

  private _count = 5;

  public get count() {
    return this._count;
  }

  public get pages() {
    return this.target.pages.take(this._count, Math.min(Math.max(this.target.pageIndex - Math.floor(this._count / 2), 0), Math.max(this.target.pages.length - this._count, 0)));
  }

  private observer = new (window as any).ResizeObserver(() => {
    
    let test = Math.floor((this.ref.nativeElement.clientWidth - 144) / 31);
    if (test % 2 == 0) test = Math.max(1, test - 1);

    if (test != this._count) this._count = test;
  });

  public select(index: number) {
    this.target.pageIndex = index;
  }

  constructor(private ref: ElementRef) {
    this.observer.observe(this.ref.nativeElement);    
  }

  ngOnDestroy() {
    this.observer.disconnect();
  }
}
